import { useState, useEffect, useCallback } from 'react';
import { getBankAccountOtp } from '../../../services/backendAPI';

const useOTPManagement = () => {
    const [otpSent, setOtpSent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [timer, setTimer] = useState(180);
    const [canResendOTP, setCanResendOTP] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [showSnackbar, setShowSnackbar] = useState(false);

    useEffect(() => {
        let interval;
        if (otpSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setCanResendOTP(true);
        }
        return () => clearInterval(interval);
    }, [otpSent, timer]);

    const handleSendOTP = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await getBankAccountOtp();
            if (response?.status === 'success') {
                setOtpSent(true);
                setSnackbarSeverity('success');
                setSnackbarMessage('OTP sent successfully');
                setTimer(180);
                setCanResendOTP(false);
            } else {
                setSnackbarSeverity('error');
                setSnackbarMessage(response?.message || 'Failed to send OTP. Please try again.');
            }
        } catch (error) {
            setSnackbarSeverity('error');
            setSnackbarMessage(error?.message || error?.toString() || 'Failed to send OTP');
        } finally {
            setIsLoading(false);
            setShowSnackbar(true);
        }
    }, []);

    const resetOTPState = useCallback(() => {
        setOtpSent(false);
        setTimer(180);
        setCanResendOTP(false);
        setShowSnackbar(false);
        setSnackbarMessage('');
    }, []);

    return {
        otpSent,
        isLoading,
        timer,
        canResendOTP,
        snackbarMessage,
        snackbarSeverity,
        showSnackbar,
        setShowSnackbar,
        handleSendOTP,
        resetOTPState
    };
};

export default useOTPManagement;
